import { render, staticRenderFns } from "./Ziying.vue?vue&type=template&id=62ca629e&scoped=true&"
import script from "./Ziying.vue?vue&type=script&lang=js&"
export * from "./Ziying.vue?vue&type=script&lang=js&"
import style0 from "./Ziying.vue?vue&type=style&index=0&id=62ca629e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ca629e",
  null
  
)

export default component.exports